<template>
  <v-layout row wrap justify-center align-content-start>

      <v-dialog v-model="passwordChangeDialog" max-width="550" persistent>
          <v-card>
              <v-card-title class="grey lighten-2">
                  <!-- <v-icon medium color="warning">warning</v-icon> -->
                  <span class="subheading"> Change Password </span>
                  <v-btn class="close" icon right flat="flat" @click="passwordChangeDialog = false"><v-icon small >close</v-icon></v-btn>
              </v-card-title>

              <v-flex layout row wrap pt-2 pb-2>
                  <!--<v-flex xs6 pr-2 pl-2 pt-2 pb-4>-->
                      <!--<v-text-field-->
                              <!--v-model="form.email"-->
                              <!--type="text"-->
                              <!--name="email"-->
                              <!--label="Email"-->
                              <!--box-->
                      <!--&gt;</v-text-field>-->
                  <!--</v-flex>-->
                  <!--<v-flex xs6 pr-2 pl-2 pt-2 pb-4>-->
                      <!--<v-text-field-->
                              <!--v-model="form.name"-->
                              <!--type="text"-->
                              <!--name="name"-->
                              <!--label="Name"-->
                              <!--box-->
                      <!--&gt;</v-text-field>-->
                  <!--</v-flex>-->

                  <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                      <v-text-field
                              v-model="form.password"
                              type="text"
                              name="password"
                              label="Password"
                              box
                      ></v-text-field>
                  </v-flex>
              </v-flex>

              <!--<v-flex layout row wrap pt-2 pb-2 mb-4 text-xs-left text-sm-left text-md-center text-lg-center>-->
                  <!--<v-flex xs12 sm6 md4 lg4 pt-6>-->
                      <!--&lt;!&ndash;<v-text-field label="*Vehicle Make" v-model="form.device_version" :rules="[rules.required]" box ></v-text-field>&ndash;&gt;-->
                      <!--<v-autocomplete :items="$store.getters.getAllStudents.sort()" label="Student Email"-->
                                      <!--item-text="email" item-value="id" placeholder="email"-->
                                      <!--v-model="form.student_id" box >-->

                      <!--</v-autocomplete>-->
                  <!--</v-flex>-->
              <!--</v-flex>-->
              <!--<v-flex layout row wrap pt-4 mb-4>-->
              <!--<v-flex xs12 sm6 md3 lg3 pl-1 pr-1 pt-6>-->
              <!--<v-text-field type="text" v-model="form.colour" name="car_colour" label="Car Colour" box ></v-text-field>-->
              <!--</v-flex>-->
              <!--</v-flex>-->
              <v-card-actions>
                  <v-flex xs12 layout row wrap>
                      <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                          <v-btn class="error" block dark flat="flat" @click="passwordChangeDialog = false">Cancel</v-btn>
                      </v-flex>
                      <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                          <v-btn class="primary" block dark flat="flat" v-on:click="changePassword()">Ok</v-btn>
                      </v-flex>
                  </v-flex>
              </v-card-actions>
          </v-card>
      </v-dialog>
      
    <v-card width="1000px">
      <v-toolbar flat dense class="primary" dark>
        <v-toolbar-title>User {{ form.email }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn  v-show="$store.state.auth.user.role!=4" dark class="primary darken-2" flat @click="passwordChangeDialog = true"><v-icon class="pr-3">add</v-icon>Change Password</v-btn>
      </v-toolbar>
      <v-flex layout row wrap align-center justify-center pt-4 pl-4 pr-4>
        <v-flex xs12 sm6 pr-2 pl-2>
          <v-text-field
            v-model="form.email" type="text" name="userId" label="Email" box disabled
          ></v-text-field>
        </v-flex>
        <!--<v-flex xs12 sm6 pr-2 pl-2>-->
          <!--<v-text-field-->
            <!--v-model="form.last_name"-->
            <!--type="text"-->
            <!--name="userName"-->
            <!--label="Last Name"-->
            <!--box-->
          <!--&gt;</v-text-field>-->
        <!--</v-flex> -->
        <!--<v-flex xs12 sm6 pr-2 pl-2>-->
          <!--&lt;!&ndash;<v-text-field label="*Vehicle Make" v-model="form.device_version" :rules="[rules.required]" box ></v-text-field>&ndash;&gt;-->
          <!--<v-autocomplete :items="$store.getters.getUserStatuses.sort()" label="*User Status"-->
                          <!--item-text="name" item-value="id" :placeholder="form.role"-->
                          <!--v-model="form.role" :rules="[rules.required]" box >-->

          <!--</v-autocomplete>-->
        <!--</v-flex>-->
        <v-flex xs12 sm6 pr-2 pl-2>
          <!--<v-text-field label="*Vehicle Model" v-model="form.sim_pack" :rules="[rules.required]" box ></v-text-field>-->
          <v-autocomplete :items="$store.getters.getUserRoles.sort()" label="*User Role"
                          item-text="name" item-value="id" :placeholder="form.status"
                          v-model="form.status" :rules="[rules.required]" box disabled >

          </v-autocomplete>
        </v-flex>

        <!--<v-flex xs12 sm6 md4 lg4>-->
          <!--&lt;!&ndash;<v-text-field label="*Vehicle Make" v-model="form.device_version" :rules="[rules.required]" box ></v-text-field>&ndash;&gt;-->
          <!--<v-autocomplete :items="$store.getters.getVehicleMakes.sort()" label="*Vehicle Make"-->
                          <!--item-text="name" item-value="id"-->
                          <!--v-model="form.status" :rules="[rules.required]" box >-->

          <!--</v-autocomplete>-->
        <!--</v-flex>-->


        <!--<v-flex xs12 sm6 pr-2 pl-2>-->
          <!--<v-text-field-->
                  <!--v-model="form.password"-->
                  <!--type="password"-->
                  <!--name="password"-->
                  <!--label="New Password"-->
                  <!--box>-->

          <!--</v-text-field>-->
        <!--</v-flex>-->
        <!--<v-flex xs12 sm6 pr-2 pl-2>-->
          <!--<v-text-field-->
                  <!--v-model="form.confirmPassword"-->
                  <!--type="password"-->
                  <!--name="password"-->
                  <!--label="Confirm New Password"-->
                  <!--box-->
                  <!--@input="$v.form.confirmPassword.$touch()"-->
                  <!--:error-messages="confirmErrors"-->
          <!--&gt;</v-text-field>-->
        <!--</v-flex>-->

        <!--<v-flex xs12 sm6 pr-2 pl-2>-->
          <!--<v-text-field-->
                  <!--v-model="form.current_password"-->
                  <!--type="password"-->
                  <!--name="adminPassword"-->
                  <!--label="*Admin Password"-->
                  <!--box-->
                  <!--@input="$v.form.current_password.$touch()"-->
                  <!--:error-messages="passwordErrors">-->

          <!--</v-text-field>-->
        <!--</v-flex>-->
      </v-flex>
      <v-card-actions class="pl-4 pr-4 pb-4">
        <v-flex xs12 layout row wrap>
          <v-flex xs12 sm6 pl-2 pr-2 pb-2>
            <v-btn class="error" block dark flat="flat" @click="cancel()">Cancel</v-btn>
          </v-flex>
          <v-flex xs12 sm6 pl-2 pr-2 pb-2>
            <v-btn class="primary" block dark flat="flat" v-on:click="submit()">Save Changes</v-btn>
          </v-flex>       
        </v-flex>
      </v-card-actions> 
    </v-card>

    <v-card v-if="form.role == 2" width="1000px" >
      <AllCustomerVehicles />
      <!--<AllCustomerAccounts />-->
    </v-card>

  </v-layout>
</template>

<script>
import UserService from "@/services/UserService";
import { validationMixin } from 'vuelidate'
import { required,email,sameAs } from 'vuelidate/lib/validators'
import AllCustomerVehicles from "../admins/AllAdminStudents.vue";

export default {
  name: "EditUser",
  mixins: [validationMixin],
  components: {
      AllCustomerVehicles
  },
  data() {
    return {
      loading: false,
      loadingTime: 1000,
        passwordChangeDialog: false,
      form: { 
        first_name: null, 
        last_name: null, 
        // role: 4,
        password: null,
        confirmPassword: null,
        email: null,
        current_password: null,
        status: null,
        role: null,
      },
      rules: {
        required: value => !!value || "Required."
      },
    };
  },
  validations: {
    form: {
      // email: { required, email },
      // first_name: { required },
      // last_name: { required },
      password: {required},
      current_password: {required},
      confirmPassword: {required, sameAsPassword: sameAs('password')}
    },
  },
  mounted(){
    this.getAll();
  },
  computed: {
    passwordErrors () {
      const errors = [];
      if (!this.$v.form.password.$dirty) return errors;
      !this.$v.form.password.required && errors.push('Password is required');
      return errors
    },
    confirmErrors () {
      const errors = [];
      if (!this.$v.form.confirmPassword.$dirty) return errors;
      !this.$v.form.confirmPassword.required && errors.push('Confirm password is required');
      !this.$v.form.confirmPassword.sameAsPassword && errors.push('Passwords do not match');
      return errors
    },
  },
  methods: {
    async getAll() {
      try {
        this.form.current_password = null;
        // const statusResponse = await UserService.getAllUserStatus();
        // const rolesResponse = await UserService.getAllUserRoles();
        // console.log("statusResponse",statusResponse);
        // console.log("rolesResponse",rolesResponse);
        //
        // this.$store.dispatch("setUserRoles", rolesResponse.data.data);
        // this.$store.dispatch("setUserStatuses", statusResponse.data.data);

        this.form = JSON.parse(JSON.stringify(this.$store.state.users.editUser));
        this.form.role = this.form.role.toString();
        this.form.status = this.form.status.toString();
        console.log("json", JSON.stringify(this.$store.state.users.editUser));
        console.log("form", this.form);
      }catch (err) {
        console.log(err);
      }
    },
    cancel: function(){      
      // this.$store.dispatch('editUser', null)
      // this.$router.push({name: 'allUsers'})
      this.$router.go(-1)
    },
    async submit() {
      try {
        var color = "info";
        // console.log("submit form", this.form);
        this.form.role = parseInt(this.form.role) || null;
        this.form.status = parseInt(this.form.status) || null;
        console.log("submit form", this.form);
        const response = await UserService.update(this.form);
        // console.log(response)
        if (response.data.code > 200) {
          color = "warning";
        } else if (response.data.result == 2000) {
          color = "success";
          // this.$router.push({name: 'allUsers'})
          this.$router.go(-1);
          this.form.current_password = null;
        }
        this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "right",timeout: 3000});
      } catch (err) {
        console.log(err);
        this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "right", timeout: 3000});
      }
    },
      async changePassword(){
          var color = "info";
          console.log("changepassword");
          // var account =  JSON.parse(JSON.stringify(this.$store.state.accounts.editAccount));

          let admin = JSON.parse(JSON.stringify(this.$store.state.users.editUser));
          console.log(admin.id);

          // this.form.admin_id = admin.id;
          console.log("modify user: ", this.form);

          this.form.role = null;
          this.form.status = null;

          const response = await UserService.changePassword(this.form);
          console.log("change password response: ", response);

          if (response.data.code > 200) {
              color = "warning";
          } else if (response.data.result == 2000) {
              // this.$store.dispatch("setCustomerVehicles", response.data.data);
              // this.allItems = response.data.data;
              // this.total = response.data.total
              // console.log("allitems: ", this.allItems);
              this.getAll();
              this.passwordChangeDialog = false;
          }

          this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
      },
  }
};
</script>

<style scoped>

</style>
